import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../../_models/index';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';

var COMP = environment.component.policy;

@Component({
  selector: 'app-policy-data',
  templateUrl: './policy-data.component.html',
  styleUrls: ['./policy-data.component.css']
})
export class PolicyDataComponent implements OnInit, OnDestroy {
  sdgcomponent$ : Observable<SDGComponent>;
  results$ : Observable<ResultData[]>;
  subscription1:Subscription;
  subscription2:Subscription;
  qcgroups : Array<QuestionCategoryGroup>=[];
  qctypes : Array<any>=[];
  qtypes : Array<any>=[];
  rows: Array<Object>=[];
  rowsobj: Object;
  qtindexobj: Object;
  qtindexrevarr: Array<Object>;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".policy-click").addClass("header_active")

    this.results$ = this.resultService.getResultData(COMP);
    this.sdgcomponent$ = this.sdgComponentService.getAll(COMP);
    this.subscription1 = this.sdgcomponent$.subscribe( data => {
          var qtindex = 0;
          var qtindexobj = {};
          var qtindexrevarr = [];
          var qct : any = data['question_category_type'];
          var extra_width = 0;

          this.qctypes = Array.apply(null, Array(qct.length)).map(function () {});

          //create an array of question category types using order as array index
          for (var i=0; i < qct.length; i++){
            let cspan, rspan=1;
            if (qct[i].name=="p14")
              cspan=1;
            else
              cspan = qct[i].question_type.length;
            if(qct[i].average)
              cspan += 1;
            if(qct[i].positive_response_percent)
              cspan += 1;

            if (qct[i].name=="p2" || qct[i].name=="p10" || qct[i].name=="p12" || qct[i].name=="p13" || qct[i].name=="p14" )
              rspan=2;
            var min_col_width = 0, qctl=0;
            if(qct[i].display_text){
              qctl = qct[i].display_text.length;
              if(qctl>50)
                min_col_width = qctl*2;
            }

            this.qctypes[qct[i].order-1] = {"name":qct[i].name,"cspan":cspan,"rspan":rspan,"question_type":qct[i].question_type,
              "category_group":qct[i].category_group, "order":qct[i].order, "display_text": qct[i].display_text,
              "average": qct[i].average, "positive_response_percent": qct[i].positive_response_percent,
              "aggregate_title": qct[i].aggregate_title, "min_col_width": min_col_width}
          }
          //slice the last element is for Pool
          this.qctypes.splice(-1,1);

          //create an array of question category type groups
          var qcgroup=this.qctypes[0].category_group;
          var groupspan=0;
          for (var i=0; i < this.qctypes.length; i++){
            if(this.qctypes[i].category_group == qcgroup){
              groupspan += this.qctypes[i].cspan;
            }
            else{
              this.qcgroups.push({"name":qcgroup,"span":groupspan});
              qcgroup = this.qctypes[i].category_group;
              groupspan = this.qctypes[i].cspan;
            }
          }
          this.qcgroups.push({"name":qcgroup,"span":groupspan});

          //create an array of question types using order as array index going through all qctypes and all qtypes within each qctype
          for (var i=0; i < this.qctypes.length; i++){

            var qctypeobj = this.qctypes[i];
            var qtarr = this.qctypes[i].question_type;

            //create an array of qtypes in one qctype
            var arr = Array.apply(null, Array(qtarr.length)).map(function () {});
            for (var j=0; j < qtarr.length; j++)
              if(this.qctypes[i].name=="p14" && qtarr[j].name=="Other")
                continue;
              else
                arr[qtarr[j].order-1] = {id:qtarr[j].id,"name":qtarr[j].name,order:qtarr[j].order, display_text: qtarr[j].display_text};

            //add above qtypes into the lookup table for qtypeid => qtypeindex (column order)
            //and reverse lookup columnorder => qtype
            for (var k=0; k < arr.length; k++){
              if(arr[k] != undefined){
              if(arr[k].name != '2 Default' && arr[k].name != '10 Default' && arr[k].name != '12 Default' && arr[k].name != '13 Default' && arr[k].name != '14a' )
                this.qtypes.push(arr[k]);
                qtindexobj[arr[k].id] = qtindex;
                qtindexrevarr[qtindex] = arr[k].name;
                qtindex++;
              }
            }

            //move qtindex forward to add columns for avearage and response if needed
             if(qctypeobj.average){
               this.qtypes.push({id:0,"name":"Average",order:this.qtypes[this.qtypes.length-1].order, display_text: qctypeobj.aggregate_title});
               qtindexrevarr[qtindex] = "Average";
               qtindex++;
             }
             if(qctypeobj.positive_response_percent){
               this.qtypes.push({id:0,"name":"+ve Response %",order:this.qtypes[this.qtypes.length-1].order, display_text: qctypeobj.aggregate_title});
               qtindexrevarr[qtindex] = "Response";
               qtindex++;
             }
          }

          for (var l=0; l < this.qtypes.length; l++){
            var qtl=0, min_col_width=0;
            if(this.qtypes[l].display_text){
              qtl = this.qtypes[l].display_text.length;
              if (qtl>10)
                min_col_width = qtl*2;
            }
            this.qtypes[l].min_col_width = min_col_width;
          }
          this.qtindexobj = qtindexobj;
          this.qtindexrevarr = qtindexrevarr;

          var ctar = data['category'];
          var rows = {};
          var row = {};
          var roworder = 0;

          function get_subcat_index(co, sco){
          /*co category order, sco subcategory order, sci subcat_index*/
            let sci;
            if (co==1 && sco==1) sci = 0;
            if (co==2 && sco==1) sci = 1;
            if (co==3 && sco==1) sci = 2;
            if (co==3 && sco==2) sci = 3;
            if (co==4 && sco==1) sci = 4;
            if (co==4 && sco==2) sci = 5;
            if (co==5 && sco==1) sci = 6;
            if (co==5 && sco==2) sci = 7;
            if (co==6 && sco==1) sci = 8;
            return sci;
          }
          function label_name(ct){
            return ct.name.replace("Target ","").replace("Indicator ","");
          }
          for (var c = 0; c < ctar.length; c++){
            var ct = ctar[c];
            row["catname"] = label_name(ct);
            var scl = ct.sub_category.length;
            row["rowspan"] = scl;
            var catrow1 = true;
            for (var sc = 0; sc < scl; sc++){
              var sct = ct.sub_category[sc];
              roworder = get_subcat_index(ct.order,sct.order);
              var newrow = {catname:row["catname"], rowspan:row["rowspan"], roworder:roworder};
              newrow["subcatname"] = label_name(sct);
              newrow["catrow"] = catrow1;
              if(sct.order == 2)
                newrow["rowspan"] = 0;
              catrow1 = false;
              var resultsarr = Array.apply(null, Array(qtindex)).map(function () {});
              newrow["resultsarr"] = resultsarr;
              rows[sct.id] = newrow;
            }
          }
          this.rowsobj = rows;
          this.subscription2 = this.results$.subscribe( data => {
              var rows_temp = [];
                for(var i=0;i<data.length;i++){
                  var res = data[i];
//                  if(res.question_category_type_name == 'p6')
//                    console.log('p6');
//                  if(res.question_category_type_name=='p2')
//                    res.value = res.value.toString() + '%';
//                  if(res.question_category_type_name=='9. At central Government level, what are the main governance challenges in water policy-making?')
//                    if(res.value == 'Unknown')
//                      res.value = 'N/A';
//                  if(res.display_value)
//                    res.value=res.display_value;

                  var colidx = this.qtindexobj[res.question_type];
                  this.rowsobj[res.sub_category].resultsarr[colidx] = res;
                }

                //go through each row to calculate aggregate columns
                var data_valid;
                for(var ri in this.rowsobj){
                  data_valid = true;
                  var rowresults = this.rowsobj[ri].resultsarr;
                  var all_3 = true, count_1 = 0, count_non_empty = 0;
                  var p5a=0, p5b=0, p5c=0, p5d=0, p5e=0, p5o=0, p5=0,response14 = 0;
                  var curr_qcat_name = '', curr_qtype_name = '';
                  //go through each result in the row, compute aggregate (average, proportion etc)
                  //at the end of results in a question category and save them
                  for(var rri = 0; rri < rowresults.length; rri++){

                    var resobj = rowresults[rri];
                    if(resobj){
                      curr_qcat_name = resobj.question_category_type_name;
                      curr_qtype_name = resobj.question_type_name;
                    }

                    if(curr_qcat_name == 'p5'){
                      if (this.qtindexrevarr[rri] == 'Response'){
                          if(p5e==1) p5 = 1;
                          else if(p5b==1) p5 = 0.5;
                          else if(p5d==1) p5 = 0.75;
                          else if(p5c==1) p5 = 0.5;
                          else if(p5a==1) p5 = 0;
                          else if(p5o==1) p5 = 0.5;
                          p5 *= 100;
                          let response5 = p5.toFixed(0) + '%';
                          rowresults[rri] = {value:response5};
                      }
                      else{
//                      r=a, s=b, t=c, u=d, v=e, w=o
//                      =IF(V7="Yes",1,IF(S7="Yes, Partial",0.5,IF(U7="Yes, Partial",0.75,IF(T7="Yes, Partial",0.5,IF(R7="No, in development",0,IF(W7="Other",0.5))))))
                        if(resobj.value_weight == 1){
                          if(curr_qtype_name == '5e')
                            p5e = 1;
                          else if(curr_qtype_name == '5d')
                            p5d = 1;
                          else if(curr_qtype_name == '5b')
                            p5b = 1;
                          else if(curr_qtype_name == '5c')
                            p5c = 1;
                          else if(curr_qtype_name == '5o')
                            p5o = 1;
                        }
                        else if(resobj.value_weight == 2 && curr_qtype_name == '5a')
                            p5a = 1;
                      }
                    }
                    else if(curr_qcat_name == 'p6' || curr_qcat_name == 'p8' || curr_qcat_name == 'p9'){
                     if (this.qtindexrevarr[rri] == 'Response'){
                       var v,response_value;
                        if(all_3)
                          v = 0; //9999
                        else
                          v = (count_1/count_non_empty) * 100;
                        response_value = v.toFixed(0) + '%'
                       rowresults[rri] = {value:response_value};
                       all_3 = true, count_1 = 0, count_non_empty = 0;
                     }
                     else if(resobj){
                        count_non_empty++;
                        all_3 = (resobj.value_weight == 3 && all_3);
                        if(resobj.value_weight == 1)
                          count_1++;
                     }
                    }
                    if(curr_qcat_name == 'p14'){
                      if (this.qtindexrevarr[rri] == 'Response'){
                      response14 = response14 * 100;
                      var response14_val = response14.toString() + '%';
                        rowresults[rri] = {value:response14_val};
                      }
                      else{
                        if(resobj.value_weight == 1)
                            response14 = 1;
                        if(resobj.value_weight == 2)
                            response14 = 0.75;
                        if(resobj.value_weight == 3)
                            response14 = 0.5;
                        if(resobj.value_weight == 4)
                            response14 = 0;
                      }
                    }
                  }

                  for(var rri = 0; rri < rowresults.length; rri++){
                    if(!rowresults[rri])
                      data_valid = false;
                  }
                  if(data_valid)
                    rows_temp.push(this.rowsobj[ri]);
                }
               var rows_ordered = Array.apply(null, Array(rows_temp.length)).map(function () {});
               for (var r=0; r<rows_temp.length; r++)
                rows_ordered[rows_temp[r].roworder] = rows_temp[r];

               this.rows = rows_ordered;
               console.log('this.rows');
               console.log(this.rows);
              },
              error => {
                this.alertService.error(error);
              });
        },
        error => {
          this.alertService.error(error);
        });
  }

  empty_objects(objects_arrays){
    for (var j=0; j<objects_arrays.length; j++){
      var props = Object.getOwnPropertyNames(objects_arrays[j]);
      for (var i = 0; i < props.length; i++) {
        delete objects_arrays[j][props[i]];
      }
    }
  }

  ngOnDestroy() {
    //  used in template
    this.qcgroups = null;
    this.qctypes = null;
    this.qtypes = null;
    this.rows = null;

    if(this.subscription1)
      this.subscription1.unsubscribe();
    if(this.subscription2)
      this.subscription2.unsubscribe();
  }

  policyBtnClick(){
    this.router.navigateByUrl('/sdg/policy')
  }
  quesBtnClick(){
    this.router.navigateByUrl('/sdg/policy-quest')
  }
  dataBtnClick(){
    this.router.navigateByUrl('/sdg/policy-data')
  }
  reportBtnClick(){
    this.router.navigateByUrl('/sdg/policy-report')
  }
}



// WEBPACK FOOTER //
// ./src/app/sdg/policy-data/policy-data.component.ts